import { useContext } from 'react';

import { HoneycombTextSizeContext } from '../context/honeycomb-text-size.context.js';

export const useHoneycombTextSize = () => useContext(HoneycombTextSizeContext);
